import { SUBMIT_GIVEFORM , SUBMIT_GIVEFORM_RESPONSE, RESET_SUBMIT_GIVEFORM } from '../actions/index';

export default function forms(state = {
    isFetching: false,
    status:'',
    error: null,
    message:''
  }, action) {
        switch (action.type) {
            case SUBMIT_GIVEFORM:
                return {...state, isFetching: true, status: 'pending',  error: null}
            case SUBMIT_GIVEFORM_RESPONSE:
                if(action.payload.data.status === 200) {
                    return {...state, isFetching: false, status:'success', message:action.payload.data.message}
                }
                else if (action.payload.data.status === 500) {
                    return {...state, isFetching: false, status:'error', message:action.payload.data.message}
                }
                break;
            case RESET_SUBMIT_GIVEFORM:
                return {...state, isFetching: false, status: '',  error: null, message:''}
            default:
                return state
        }
  }